export const timeLogsConstants = {
    errors: {
        fetchFailed: "Failed to load time logs.",
        createFailed: "Failed to add time log.",
        updateFailed: "Failed to update time log.",
        deleteFailed: "Failed to delete time log.",
    },
    messages: {
        createSuccess: "Time log added.",
        updateSuccess: "Time log updated.",
        deleteSuccess: "Time log deleted.",
    },
};
